import * as yup from 'yup';
import { checkDateIsLower } from 'utils/date';

export const expeditionBuyerConfirmationSchema = (pt: any, expeditionDate: Date | null): yup.AnyObjectSchema =>
  yup.object().shape({
    weight: yup
      .number()
      .transform(value => (isNaN(value) ? undefined : value))
      .required(pt('weight.required'))
      .typeError(pt('weight.invalid'))
      .moreThan(0, pt('weight.required')),
    confirmationDate: yup
      .date()
      .typeError(pt('confirmationDate.required'))
      .nullable()
      .required(pt('confirmationDate.required'))
      .max(new Date(), pt('confirmationDate.previousThanToday'))
      .test('beforeExpeditionDate', pt('confirmationDate.beforeExpeditionDate'), value =>
        checkDateIsLower(expeditionDate, value),
      ),
  });
